import { createContext } from 'react';

import type { ModalContextValue, ModalManagerContextValue } from './Modal.types';

const initialMethods = {
  update: () => {},
  dismiss: () => {},
  activate: () => {},
  minimize: () => {},
  maximize: () => {},
  dock: () => {},
  unmount: () => {}
};

export const initialModalContext: ModalContextValue = {
  alert: false,
  dismissible: true,
  minimizable: false,
  maximizable: false,
  dockable: false,
  defaultMinimized: false,
  unmountWhenMinimized: true,
  state: 'open',
  top: false,
  initialized: false,
  ...initialMethods
};

export const ModalContext = createContext<ModalContextValue>(initialModalContext);

export const ModalManagerContext = createContext<ModalManagerContextValue>({
  create: () => initialMethods,
  ModalContext,
  initialized: false,
  lastFocusedBeforeProgress: { current: null }
});
